export default "<div class=\"main-content\">\n  <app-files [canEdit]=\"true\"></app-files>\n</div>\n";